import * as monaco from "monaco-editor";
export class MonacoEditor {
    constructor(editor) {
        this.editor = editor;
    }
    static instance(element, content = '') {
        if (!this.INSTANCE && element) {
            const editor = monaco.editor.create(element, {
                value: content,
                language: 'java',
                theme: 'vs-dark',
                contextmenu: false,
                minimap: {
                    enabled: false
                }
            });
            const firepadRef = MonacoEditor.createFirepadRef();
            const firepad = require('firepad');
            firepad.fromMonaco(firepadRef, editor);
            this.INSTANCE = new MonacoEditor(editor);
        }
        return this.INSTANCE;
    }
    highlightCurrentSelection() {
        const sel = this.editor.getSelection();
        if (sel) {
            this.editor.deltaDecorations([], [
                {
                    range: this.createRange(sel.getStartPosition(), sel.getEndPosition()),
                    options: { inlineClassName: 'editor-highlight-code' }
                },
            ]);
        }
    }
    setContent(content) {
        this.editor.setValue(content);
    }
    createRange(startPos, endPost) {
        return new monaco.Range(startPos.lineNumber, startPos.column, endPost.lineNumber, endPost.column);
    }
    static createFirepadRef() {
        // Helper to get hash from end of URL or generate a random one.
        // @ts-ignore
        var ref = firebase.app().database().ref();
        var hash = window.location.hash.replace(/#/g, '');
        if (hash) {
            ref = ref.child(hash);
        }
        else {
            ref = ref.push(); // generate unique location.
            window.location.href = window.location + '#' + ref.key; // add it as a hash to the URL.
        }
        if (typeof console !== 'undefined') {
            console.log('Firebase data: ', ref.toString());
        }
        return ref;
    }
}
